<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择" style="width: 180px;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-date-picker v-model="formDatas.xxYearMonth" type="month" value-format="yyyyMM"
                        placeholder="小象年月" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.asrYearMonth" type="month" value-format="yyyyMM"
                        placeholder="微信平台年月" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <!-- 状态 -->
                    <el-select v-model="formDatas.asrStatus" placeholder="状态" size="mini" clearable
                        style="width: 120px; margin-left: 10px" @change="partserch">
                        <el-option label="创建" :value="1"></el-option>
                        <el-option label="待商户上传" :value="2"></el-option>
                        <el-option label="商户已上传" :value="3"></el-option>
                        <el-option label="待商户修改" :value="4"></el-option>
                        <el-option label="已完成" :value="5"></el-option>
                        <el-option label="已入账" :value="6"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                </el-row>

            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="reCalc">执行</el-button>

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="acexrId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
let Base64 = require('js-base64').Base64
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { updateAjefShopReceiptStatusCheckMulti, updateAjefCertificateRecordXiaoxiangReceiptHandler, getAjefShopListQuick, updateAjefShopReceiptStatusCheck, getAjefCertificateRecordXiaoxiangReceiptList, addAjefShopReceipt, updateAjefShop, updateAjefShopReceiptStatusSend, updateAjefShopReceipt } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            isAudit: false,
            formAudit: {},
            isBulkDete: false,
            formDate: {},
            invoiceEditDialog: false,
            formIc: {},

            getAjefShopList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'acexrId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                
                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    fixed: 'left',
                    edit: false,
                    width: 140,
                },
                {
                    field: "xxYearMonth",
                    key: "xxYearMonth",
                    title: "小象年月",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "orderMoneyYuan",
                    key: "orderMoneyYuan",
                    title: "平台订单金额",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                // {
                //     field: "asrtId",
                //     key: "asrtId",
                //     title: "商户开票结算类型id",
                //     align: "center",
                //     edit: false,
                //     width: 140,
                // },
                {
                    field: "asrtDistributionRatio",
                    key: "asrtDistributionRatio",
                    title: "结算比例",
                    align: "center",
                    edit: false,
                    width: 80,
                },
                {
                    field: "orderMoneyXiaoxiangYuan",
                    key: "orderMoneyXiaoxiangYuan",
                    title: "渠道商结算额",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                // {
                //     field: "asrId",
                //     key: "asrId",
                //     title: "商户发票记录id",
                //     align: "center",
                //     edit: false,
                //     width: 120,
                // },
                {
                    field: "asrYearMonth",
                    key: "asrYearMonth",
                    title: "微信年月",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                 {
                    field: "acexrMoneyXxMonthYuan",
                    key: "acexrMoneyXxMonthYuan",
                    title: "核销额",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "asrMoney",
                    key: "asrMoney",
                    title: "开票金额",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "asrStatus",
                    key: "asrStatus",
                    title: "状态",
                    align: "center",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.asrStatus === 1 ? <el-tag size="mini" type="info">创建</el-tag> :
                                        row.asrStatus === 2 ? <el-tag size="mini" type="warning">待商户上传</el-tag> :
                                            row.asrStatus === 3 ? <el-tag size="mini" type="primary">商户已上传</el-tag> :
                                                row.asrStatus === 4 ? <el-tag size="mini" type="danger">待商户修改</el-tag> :
                                                    row.asrStatus === 5 ? <el-tag size="mini" type="success">已完成</el-tag> :
                                                        row.asrStatus === 6 ? <el-tag size="mini" type="info">已入账</el-tag> :
                                                            <el-tag size="mini" type="default">未知</el-tag>
                                }
                            </span>
                        );
                    },
                },
                // {
                //     field: "acexrMoneyMonths",
                //     key: "acexrMoneyMonths",
                //     title: "月份核销额",
                //     align: "center",
                //     edit: false,
                //     width: 320,
                // },
                {
                    field: "acexrMoneyMonthNextOne",
                    key: "acexrMoneyMonthNextOne",
                    title: "下1个月核销额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "acexrMoneyMonthNextTwo",
                    key: "acexrMoneyMonthNextTwo",
                    title: "下2个月核销额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "acexrMoneyMonthNextThree",
                    key: "acexrMoneyMonthNextThree",
                    title: "下3个月核销额",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                 {
                    field: "acexrReceiptShop",
                    key: "acexrReceiptShop",
                    title: "商户已开票",
                    align: "center",
                    edit: false,
                    width: 110,
                },
                 {
                    field: "acexrReceiptCaiwu",
                    key: "acexrReceiptCaiwu",
                    title: "财务已收票",
                    align: "center",
                    edit: false,
                    width: 110,
                },
                 {
                    field: "acexrReceiptDifference",
                    key: "acexrReceiptDifference",
                    title: "发票补差",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acexrReceiptDifferenceOrderMoneyYuan",
                    key: "acexrReceiptDifferenceOrderMoneyYuan",
                    title: "本月核销券额",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acexrReceiptTypeFinance",
                    key: "acexrReceiptTypeFinance",
                    title: "票种",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "acexrReceiptTypeFinanceRate",
                    key: "acexrReceiptTypeFinanceRate",
                    title: "票种结算比例",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                 {
                    field: "acexrReceiptOwe",
                    key: "acexrReceiptOwe",
                    title: "欠票金额",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "updatetime",
                    key: "updatetime",
                    title: "更新时间",
                    align: "center",
                    edit: false,
                    width: 160,
                }
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                xxYearMonth:"202508",
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},
            tableLoading: false,

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        reCalc() {
            this.$confirm("是否确定执行吗?, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.openLoading()
                    updateAjefCertificateRecordXiaoxiangReceiptHandler({}).then(res => {
                        this.loadings.close()
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.getList();
                        }
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        HandleAudit(row) {
            this.formAudit.acexrId = row.acexrId
            this.isAudit = true;
        },
        isAuditClose() {
            this.isAudit = false;
            this.formAudit = {};
            this.$refs.formRef4.resetFields();
        },
        BulkEditHandlerDate() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    message: "请选择要修改的数据",
                    type: "warning"
                });
                return
            }
            this.isBulkDete = true;
        },
        isBulkDeteClose() {
            this.isBulkDete = false;
            this.checkboxOption.selectedRowKeys = [];
            this.selectedRowKeysCollection = [];
            this.$refs.formRef3.resetFields();
        },
        isBulkDeteSureBtn() {
            //    是否确认编辑
            this.$confirm("是否确定吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const acexrIds = this.selectedRowKeysCollection.toString();
                    const checkHandlerDate = this.formDate.checkHandlerDate;
                    updateAjefShopReceiptStatusCheckMulti({ acexrIds, checkHandlerDate }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "修改成功!",
                            });
                            this.isBulkDeteClose();
                            this.getList();
                        }
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        invoiceEditDialogOpen(row) {
            this.formIc = JSON.parse(JSON.stringify(row));
            this.invoiceEditDialog = true
        },
        invoiceEditDialogClose() {
            this.invoiceEditDialog = false;
            this.$refs.formRef2.resetFields();
        },
        invoiceEditSureBtn() {
            //    是否确认编辑
            this.$confirm("是否确定吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopReceipt(this.formIc).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                            this.invoiceEditDialogClose();
                            this.getList();
                        }
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record-xiaoxiang-receipt/exportAjefCertificateRecordXiaoxiangReceipt',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '发票明细统计记录.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        getAjefShopListChange(val) {
            console.log(val);
            this.getAjefShopList_data.forEach((item, index) => {
                if (item.asId == val) {
                    this.form.asrDes = item.asrtReceiptTypeName
                }
            })

        },
        downloadFile(url, name) {
            //下载
            if (!url) {
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.target = '_blank';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        Preview(url) {
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)));
        },
        handleCheck() {
            this.$confirm("是否确定通过审核吗?, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.formAudit))
                    newForm.acexrIdPass = 2
                    updateAjefShopReceiptStatusCheck(newForm).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });
                        this.isAuditClose()
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleRefuseCheck() {
            this.$confirm("是否确定驳回审核吗?, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.formAudit))
                    newForm.acexrIdPass = 1
                    updateAjefShopReceiptStatusCheck(newForm).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });

                        this.isAuditClose()
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjefShopReceiptInBill(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data;
                this.bulkDataCopy = res.data
            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ acexrId: this.theRow.acexrId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShopReceiptStatusSend({ acexrIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopReceiptStatusSend({ acexrIds: row.acexrId }).then(res => {
                        this.$message({
                            type: "success",
                            message: "成功!",
                        });

                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        addAjefShopReceipt(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShop(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acexrId = row.acexrId
                    console.log(jsonObj);
                    updateAjefShop(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = [...new Set(this.selectedRowKeysCollection.concat(selectedRowKeys))] || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefCertificateRecordXiaoxiangReceiptList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefCertificateRecordXiaoxiangReceiptList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefCertificateRecordXiaoxiangReceiptList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.tableLoading = false;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>